module.exports = __webpack_public_path__ + "img/jujue.d27fa26c.png";